export default "__VITE_ASSET__DCzhIviT__"